import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Plus,
  ChevronDown,
  ChevronRight,
  Clock4,
  FilePlus2,
  CalendarCheck2,
  CalendarPlus,
  CalendarDays,
  Album,
  Megaphone,
  BookOpenText,
  FileClock,
  Users,
  UserCheck,
  UserPlus,
  UserX,
  Clock,
  List,
  PlusCircle,
  Mail,
  Camera,
  LayoutDashboard,
  Image,
  PanelLeft,
  GraduationCap,
  School,
  BookOpen,
  PlusCircleIcon,
} from "lucide-react";
import PageWrapper from "./PageWrapper";
import Logo from "../../../assets/img/logo/logo.png";
import Line from "../../../assets/img/admin/line.png";
import { useUserData } from "../../../hooks/useUserData";

// Original menu items for admin users
const adminMenuItems = [
  {
    key: "admin/dashboard",
    icon: LayoutDashboard,
    label: "Dashboard",
    subItems: [],
    module: "Dashboard",
  },
  {
    key: "users",
    icon: Users,
    label: "Admin Portal Users",
    module: "Admin Portal Users",
    subItems: [
      { icon: UserPlus, label: "Add New User", href: "/admin/users/add" },
      { icon: List, label: "User List", href: "/admin/users/list" },
    ],
  },
  {
    key: "jobs",
    icon: FilePlus2,
    label: "Jobs",
    module: "Jobs",
    subItems: [
      { icon: Plus, label: "Add Job", href: "/admin/jobs/add" },
      { icon: List, label: "Job List", href: "/admin/jobs/list" },
    ],
  },
  {
    key: "education",
    icon: GraduationCap,
    label: "Education",
    module: "Education",
    subItems: [
      { icon: Plus, label: "Add Education", href: "/admin/education/add" },
      {
        icon: BookOpen,
        label: "Education List",
        href: "/admin/education/list",
      },
      { icon: School, label: "Manage Degree", href: "/admin/education/degree" },
    ],
  },
  {
    key: "gallery",
    icon: Image,
    label: "Gallery",
    module: "Gallery",
    subItems: [
      { icon: Album, label: "Gallery list", href: "/admin/gallery/list" },
      {
        icon: PanelLeft,
        label: "Pending Gallery list",
        href: "/admin/gallery/pending",
      },
      { icon: Plus, label: "Add Gallery", href: "/admin/gallery/add" },
    ],
  },
  {
    key: "news",
    icon: Megaphone,
    label: "News",
    module: "News",
    subItems: [
      { icon: BookOpenText, label: "News list", href: "/admin/news/list" },
      { icon: FileClock, label: "Pending News", href: "/admin/news/pending" },
      { icon: FilePlus2, label: "Add News", href: "/admin/news/add" },
    ],
  },
  {
    key: "events",
    icon: CalendarDays,
    label: "Events",
    module: "Events",
    subItems: [
      {
        icon: CalendarCheck2,
        label: "Events List",
        href: "/admin/events/list",
      },
      {
        icon: Clock4,
        label: "Pending Events List",
        href: "/admin/events/pending",
      },
      { icon: CalendarPlus, label: "Add Event", href: "/admin/events/add" },
      {
        icon: List,
        label: "Category",
        href: "/admin/events/category",
      },
    ],
  },
  // NEW: WAS - SAP Event Module
  {
    key: "was-sap-events",
    icon: CalendarDays,
    label: "WAS - SAP Event",
    module: "WAS - SAP Event",
    subItems: [
      {
        icon: CalendarCheck2,
        label: "WAS - SAP Events List",
        href: "/admin/was-sap-events/list",
      },
    ],
  },

  {
    key: "aqua-event-2026",
    icon: CalendarDays,
    label: "Aqua Event 2026",
    module: "Events",
    subItems: [
      {
        icon: CalendarCheck2,
        label: "Aqua Event 2026 Map",
        href: "/admin/aqua-event-2026/list",
      },
    ],
  },
  {
    key: "members",
    icon: Users,
    label: "Members",
    module: "Members",
    subItems: [
      { icon: Users, label: "Members List", href: "/admin/members/list" },
      {
        icon: Clock,
        label: "Pending Members",
        href: "/admin/members/pending",
      },
      {
        icon: UserCheck,
        label: "Approved Members",
        href: "/admin/members/approved",
      },
      {
        icon: UserX,
        label: "Rejected Members",
        href: "/admin/members/rejected",
      },
      {
        icon: List,
        label: "Designation List",
        href: "/admin/members/designation/list",
      },
      {
        icon: PlusCircle,
        label: "Add Designation",
        href: "/admin/members/designation/add",
      },
      {
        icon: PlusCircleIcon,
        label: "Add Member",
        href: "/admin/members/add",
      },
      {
        href: "/admin/leadership-role",
        icon: Users,
        label: "Leadership Role",
      },
    ],
  },
  {
    key: "students",
    icon: BookOpen,
    label: "Students",
    module: "Students",
    subItems: [
      {
        icon: Clock,
        label: "Pending Students",
        href: "/admin/members/students/pending",
      },
      {
        icon: Users,
        label: "Student List",
        href: "/admin/members/students/list",
      },
      {
        icon: Clock4,
        label: "Expired Students",
        href: "/admin/members/students/expired",
      },
      {
        icon: UserCheck,
        label: "Approved Students",
        href: "/admin/members/students/approved",
      },
    ],
  },
  {
    key: "photoSlogan",
    icon: Camera,
    label: "Photo Slogan",
    module: "Photo Slogan",
    subItems: [
      {
        icon: Camera,
        label: "Manage Photo Slogan",
        href: "/admin/photo-slogan",
      },
    ],
  },
  {
    key: "subscribers",
    icon: Mail,
    label: "Newsletter Hub",
    module: "Newsletter Hub",
    subItems: [
      {
        icon: UserPlus,
        label: "All Subscribers",
        href: "/admin/subscribers",
      },
    ],
  },
  {
    key: "communication",
    icon: Mail,
    label: "Communication",
    module: "Communication",
    subItems: [
      {
        icon: Mail,
        label: "SMS",
        subItems: [
          {
            icon: Users,
            label: "Groups",
            href: "/admin/communication/sms/groups",
          },
          {
            icon: BookOpenText,
            label: "Templates",
            href: "/admin/communication/sms/templates",
          },
          {
            icon: Mail,
            label: "Send / Schedule",
            href: "/admin/communication/sms/send-schedule",
          },
        ],
      },
      {
        icon: Mail,
        label: "WhatsApp",
        subItems: [
          {
            icon: Users,
            label: "Groups",
            href: "/admin/communication/whatsapp/groups",
          },
          {
            icon: BookOpenText,
            label: "Templates",
            href: "/admin/communication/whatsapp/templates",
          },
          {
            icon: Mail,
            label: "Send / Schedule",
            href: "/admin/communication/whatsapp/send-schedule",
          },
        ],
      },
      {
        icon: Mail,
        label: "Email",
        subItems: [
          {
            icon: Users,
            label: "Groups",
            href: "/admin/communication/email/groups",
          },
          {
            icon: BookOpenText,
            label: "Templates",
            href: "/admin/communication/email/templates",
          },
          {
            icon: Mail,
            label: "Send / Schedule",
            href: "/admin/communication/email/send-schedule",
          },
        ],
      },
    ],
  },
];

const maintainerMenuItems = [
  {
    key: "admin/dashboard",
    icon: LayoutDashboard,
    label: "Dashboard",
    subItems: [],
    module: "Dashboard",
  },
  {
    key: "users",
    icon: Users,
    label: "Admin Portal Users",
    module: "Admin Portal Users",
    subItems: [
      { icon: UserPlus, label: "Add New User", href: "/admin/users/add" },
      { icon: List, label: "User List", href: "/admin/users/list" },
    ],
  },
  {
    key: "jobs",
    icon: FilePlus2,
    label: "Jobs",
    module: "Jobs",
    subItems: [
      { icon: Plus, label: "Add Job", href: "/admin/jobs/add" },
      { icon: List, label: "Job List", href: "/admin/jobs/list" },
    ],
  },
  {
    key: "education",
    icon: GraduationCap,
    label: "Education",
    module: "Education",
    subItems: [
      { icon: Plus, label: "Add Education", href: "/admin/education/add" },
      {
        icon: BookOpen,
        label: "Education List",
        href: "/admin/education/list",
      },
    ],
  },
  {
    key: "degree",
    icon: School,
    label: "Degree",
    module: "Degree",
    subItems: [
      { icon: School, label: "Manage Degree", href: "/admin/education/degree" },
    ],
  },
  {
    key: "gallery",
    icon: Image,
    label: "Gallery",
    module: "Gallery",
    subItems: [
      { icon: Album, label: "Gallery list", href: "/admin/gallery/list" },
      {
        icon: PanelLeft,
        label: "Pending Gallery list",
        href: "/admin/gallery/pending",
      },
      { icon: Plus, label: "Add Gallery", href: "/admin/gallery/add" },
    ],
  },
  {
    key: "news",
    icon: Megaphone,
    label: "News",
    module: "News",
    subItems: [
      { icon: BookOpenText, label: "News list", href: "/admin/news/list" },
      { icon: FileClock, label: "Pending News", href: "/admin/news/pending" },
      { icon: FilePlus2, label: "Add News", href: "/admin/news/add" },
    ],
  },
  {
    key: "events",
    icon: CalendarDays,
    label: "Events",
    module: "Events",
    subItems: [
      {
        icon: CalendarCheck2,
        label: "Events List",
        href: "/admin/events/list",
      },
      {
        icon: Clock4,
        label: "Pending Events List",
        href: "/admin/events/pending",
      },
      { icon: CalendarPlus, label: "Add Event", href: "/admin/events/add" },
      {
        icon: List,
        label: "Category",
        href: "/admin/events/category",
      },
    ],
  },
  // NEW: WAS - SAP Event Module for Maintainers
  {
    key: "was-sap-events",
    icon: CalendarDays,
    label: "WAS - SAP Event",
    module: "WAS - SAP Event",
    subItems: [
      {
        icon: CalendarCheck2,
        label: "WAS - SAP Events List",
        href: "/admin/was-sap-events/list",
      },
    ],
  },
  {
    key: "aqua-event-2026",
    icon: CalendarDays,
    label: "Aqua Event 2026",
    module: "Events",
    subItems: [
      {
        icon: CalendarCheck2,
        label: "Aqua Event 2026 Map",
        href: "/admin/aqua-event-2026/list",
      },
    ],
  },
  {
    key: "members",
    icon: Users,
    label: "Members",
    module: "Members",
    subItems: [
      { icon: Users, label: "Members List", href: "/admin/members/list" },
      {
        icon: Clock,
        label: "Pending Members",
        href: "/admin/members/pending",
      },
      {
        icon: UserCheck,
        label: "Approved Members",
        href: "/admin/members/approved",
      },
      {
        icon: UserX,
        label: "Rejected Members",
        href: "/admin/members/rejected",
      },
    ],
  },
  {
    key: "designation",
    icon: List,
    label: "Designation List",
    module: "Designation List",
    subItems: [
      {
        icon: List,
        label: "Designation List",
        href: "/admin/members/designation/list",
      },
      {
        icon: PlusCircle,
        label: "Add Designation",
        href: "/admin/members/designation/add",
      },
    ],
  },
  {
    key: "leadership",
    icon: Users,
    label: "Leadership Role",
    module: "Leadership Role",
    subItems: [
      {
        href: "/admin/leadership-role",
        icon: Users,
        label: "Leadership Role",
      },
    ],
  },
  {
    key: "students",
    icon: BookOpen,
    label: "Students",
    module: "Students",
    subItems: [
      {
        icon: Clock,
        label: "Pending Students",
        href: "/admin/members/students/pending",
      },
      {
        icon: Users,
        label: "Student List",
        href: "/admin/members/students/list",
      },
      {
        icon: Clock4,
        label: "Expired Students",
        href: "/admin/members/students/expired",
      },
      {
        icon: UserCheck,
        label: "Approved Students",
        href: "/admin/members/students/approved",
      },
    ],
  },
  {
    key: "photoSlogan",
    icon: Camera,
    label: "Photo Slogan",
    module: "Photo Slogan",
    subItems: [
      {
        icon: Camera,
        label: "Manage Photo Slogan",
        href: "/admin/photo-slogan",
      },
    ],
  },
  {
    key: "subscribers",
    icon: Mail,
    label: "Newsletter Hub",
    module: "Newsletter Hub",
    subItems: [
      {
        icon: UserPlus,
        label: "All Subscribers",
        href: "/admin/subscribers",
      },
    ],
  },
  {
    key: "communication",
    icon: Mail,
    label: "Communication",
    module: "Communication",
    subItems: [
      {
        icon: Mail,
        label: "SMS",
        subItems: [
          {
            icon: Users,
            label: "Groups",
            href: "/admin/communication/sms/groups",
          },
          {
            icon: BookOpenText,
            label: "Templates",
            href: "/admin/communication/sms/templates",
          },
          {
            icon: Mail,
            label: "Send / Schedule",
            href: "/admin/communication/sms/send-schedule",
          },
        ],
      },
      {
        icon: Mail,
        label: "WhatsApp",
        subItems: [
          {
            icon: Users,
            label: "Groups",
            href: "/admin/communication/whatsapp/groups",
          },
          {
            icon: BookOpenText,
            label: "Templates",
            href: "/admin/communication/whatsapp/templates",
          },
          {
            icon: Mail,
            label: "Send / Schedule",
            href: "/admin/communication/whatsapp/send-schedule",
          },
        ],
      },
      {
        icon: Mail,
        label: "Email",
        subItems: [
          {
            icon: Users,
            label: "Groups",
            href: "/admin/communication/email/groups",
          },
          {
            icon: BookOpenText,
            label: "Templates",
            href: "/admin/communication/email/templates",
          },
          {
            icon: Mail,
            label: "Send / Schedule",
            href: "/admin/communication/email/send-schedule",
          },
        ],
      },
    ],
  },
];

const Sidebar = () => {
  const { pathname } = useLocation();

  const [maintainerData, setMaintainerData] = useState(null);
  const [filteredMenuItems, setFilteredMenuItems] = useState([]);

  const { userRole, maintainerData: maintainerDatas } = useUserData();

  useEffect(() => {
    if (maintainerDatas) {
      setMaintainerData(maintainerDatas);
    }
  }, [maintainerDatas]);

  useEffect(() => {
    if (userRole === "admin") {
      setFilteredMenuItems(adminMenuItems);
    } else if (userRole === "maintainer" && maintainerData?.permissions) {
      const permissionsMap = maintainerData.permissions.reduce(
        (acc, permission) => {
          acc[permission.module] = permission;
          return acc;
        },
        {}
      );

      const filtered = maintainerMenuItems
        .filter((item) => {
          const modulePermission = permissionsMap[item.module];

          if (item.module === "Communication") {
            return (
              modulePermission &&
              (modulePermission.whatsapp ||
                modulePermission.sms ||
                modulePermission.email)
            );
          }

          return modulePermission && modulePermission.view === true;
        })
        .map((item) => {
          const modulePermission = permissionsMap[item.module];

          if (item.module === "Communication") {
            const filteredSubItems = item.subItems
              .filter((subItem) => {
                if (subItem.label === "SMS") {
                  return modulePermission.sms;
                } else if (subItem.label === "WhatsApp") {
                  return modulePermission.whatsapp;
                } else if (subItem.label === "Email") {
                  return modulePermission.email;
                }
                return false;
              })
              .map((subItem) => {
                if (subItem.subItems) {
                  const filteredNestedSubItems = subItem.subItems.filter(
                    (nestedSubItem) => {
                      const isAddItem =
                        nestedSubItem.label.toLowerCase().includes("send") ||
                        nestedSubItem.label
                          .toLowerCase()
                          .includes("schedule") ||
                        nestedSubItem.href?.includes("/send-schedule");

                      return !isAddItem || modulePermission.edit;
                    }
                  );

                  return {
                    ...subItem,
                    subItems: filteredNestedSubItems,
                  };
                }
                return subItem;
              });

            return {
              ...item,
              subItems: filteredSubItems,
            };
          }

          if (!modulePermission?.edit && item.subItems?.length > 0) {
            const filteredSubItems = item.subItems
              .filter((subItem) => {
                const isAddItem =
                  subItem.label.toLowerCase().includes("add") ||
                  subItem.href?.includes("/add") ||
                  subItem.label === "Add New User" ||
                  subItem.label.toLowerCase().includes("create") ||
                  subItem.label === "Add Designation" ||
                  subItem.label === "Add Education";

                return !isAddItem;
              })
              .map((subItem) => {
                if (subItem.subItems) {
                  return {
                    ...subItem,
                    subItems: subItem.subItems.filter((nestedSubItem) => {
                      const isNestedAddItem =
                        nestedSubItem.label.toLowerCase().includes("add") ||
                        nestedSubItem.href?.includes("/add") ||
                        nestedSubItem.label.toLowerCase().includes("create");

                      return !isNestedAddItem;
                    }),
                  };
                }
                return subItem;
              });

            return {
              ...item,
              subItems: filteredSubItems,
            };
          }

          return item;
        });

      setFilteredMenuItems(filtered);
    } else {
      setFilteredMenuItems([]);
    }
  }, [userRole, maintainerData]);

  const getInitialOpenMenus = (pathname) => {
    const initialOpen = {};

    const traverse = (items) => {
      for (const item of items) {
        if (item.subItems?.length) {
          for (const sub of item.subItems) {
            if (sub.href === pathname) {
              initialOpen[item.key] = true;
              return;
            }

            if (sub.subItems) {
              for (const subSub of sub.subItems) {
                if (subSub.href === pathname) {
                  initialOpen[item.key] = true;
                  initialOpen[`${item.key}-${sub.label}`] = true;
                  return;
                }
              }
            }
          }
        }
      }
    };

    traverse(filteredMenuItems);
    return initialOpen;
  };

  const [openMenus, setOpenMenus] = useState(() =>
    getInitialOpenMenus(pathname)
  );

  useEffect(() => {
    setOpenMenus(getInitialOpenMenus(pathname));
  }, [filteredMenuItems, pathname]);

  const toggleMenu = (key) => {
    setOpenMenus((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const SubMenuItem = ({ icon: Icon, label, href }) => {
    const isActive =
      pathname === href ||
      (href.startsWith("/admin/jobs/list") &&
        pathname.startsWith("/admin/jobs/applied")) ||
      (href.startsWith("/admin/jobs/add") &&
        pathname.startsWith("/admin/jobs/edit-job")) ||
      (href === "/admin/education/list" &&
        (pathname === "/admin/education/list" ||
          pathname.startsWith("/admin/education/view-details") ||
          pathname === "/admin/education/edit-education")) ||
      (href === "/admin/education/degree" &&
        (pathname === "/admin/education/degree" ||
          pathname.startsWith("/admin/education/degree/"))) ||
      (href === "/admin/news/list" &&
        (pathname === "/admin/news/list" ||
          pathname.startsWith("/admin/news/view-details") ||
          pathname === "/admin/news/edit-news")) ||
      (href === "/admin/events/list" &&
        (pathname === "/admin/events/list" ||
          pathname.startsWith("/admin/events/view-details") ||
          pathname === "/admin/events/edit-event")) ||
      // NEW: WAS - SAP Events active states
      (href === "/admin/was-sap-events/list" &&
        (pathname === "/admin/was-sap-events/list" ||
          pathname.startsWith("/admin/was-sap-events/view-details") ||
          pathname === "/admin/was-sap-events/edit-event")) ||
      (href === "/admin/gallery/list" &&
        (pathname === "/admin/gallery/list" ||
          pathname.startsWith("/admin/gallery/edit-gallery"))) ||
      (href === "/admin/members/list" &&
        (pathname === "/admin/members/list" ||
          pathname.startsWith("/admin/members/edit-member") ||
          pathname.startsWith("/admin/members/detail"))) ||
      (href === "/admin/members/students/list" &&
        (pathname === "/admin/members/students/list" ||
          pathname.startsWith("/admin/members/students/edit") ||
          pathname.startsWith("/admin/members/students/detail"))) ||
      (href === "/admin/members/students/pending" &&
        pathname === "/admin/members/students/pending") ||
      (href === "/admin/members/students/approved" &&
        pathname === "/admin/members/students/approved") ||
      (href === "/admin/members/students/expired" &&
        pathname === "/admin/members/students/expired") ||
      (href === "/admin/photo-slogan" && pathname === "/admin/photo-slogan");

    return (
      <Link to={href}>
        <div
          className={`flex items-center gap-2 text-sm mb-2 px-2 py-1.5 rounded-l-md transition-all duration-200 ${
            isActive
              ? "bg-white text-[#5525EB] shadow"
              : "text-white hover:!text-[#5525EB] hover:bg-white cursor-pointer"
          }`}
        >
          <Icon className="w-4 h-4 mt-[-2px]" />
          <span>{label}</span>
        </div>
      </Link>
    );
  };

  const MenuSection = ({ item }) => {
    const Icon = item.icon;
    const isOpen = openMenus[item.key];
    const hasSubItems = item.subItems && item.subItems.length > 0;

    if (!hasSubItems) {
      let isActive = false;

      if (item.key === "admin/dashboard") {
        const urlParams = new URLSearchParams(window.location.search);
        const fromDashboard = urlParams.get("from") === "dashboard";

        isActive =
          pathname === "/admin/dashboard" ||
          (pathname.startsWith("/admin/members/detail") && fromDashboard);
      }

      return (
        <Link to={`/${item.key}`}>
          <div
            className={`flex items-center gap-2 pl-3 -mr-4 ml-6 py-2 rounded-l-md transition-all duration-200 cursor-pointer mb-2 ${
              isActive
                ? "bg-white text-[#5525EB] shadow"
                : "text-white hover:bg-white hover:!text-[#5525EB]"
            }`}
          >
            <Icon className="w-4 h-4" />
            <span className="text-sm">{item.label}</span>
          </div>
        </Link>
      );
    }

    return (
      <div className="mb-2 translate-x-4">
        <div
          className="flex justify-between items-center px-3 py-2 cursor-pointer hover:bg-white hover:text-[#6C24EF] rounded-l-md transition-all duration-200 group"
          onClick={() => toggleMenu(item.key)}
        >
          <div className="flex items-center gap-2">
            <Icon className="w-4 h-4 group-hover:text-[#6C24EF]" />
            <span className="text-sm group-hover:text-[#6C24EF]">
              {item.label}
            </span>
          </div>
          {isOpen ? (
            <ChevronDown className="w-4 h-4 group-hover:text-[#6C24EF]" />
          ) : (
            <ChevronRight className="w-4 h-4 group-hover:text-[#6C24EF]" />
          )}
        </div>
        {isOpen && (
          <div className="ml-7 mt-1 text-sm space-y-1">
            {item.subItems.map((subItem, index) =>
              subItem.subItems ? (
                <div key={index}>
                  <div
                    className="flex justify-between items-center cursor-pointer text-white text-xs font-semibold py-1 hover:text-[#5525EB]"
                    onClick={() => toggleMenu(`${item.key}-${subItem.label}`)}
                  >
                    {subItem.label}
                    {openMenus[`${item.key}-${subItem.label}`] ? (
                      <ChevronDown className="w-4 h-4" />
                    ) : (
                      <ChevronRight className="w-4 h-4" />
                    )}
                  </div>
                  {openMenus[`${item.key}-${subItem.label}`] && (
                    <div className="ml-4 mt-1">
                      {subItem.subItems.map((sub, i) => (
                        <SubMenuItem
                          key={`${subItem.label}-${i}`}
                          icon={sub.icon}
                          label={sub.label}
                          href={sub.href}
                        />
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <SubMenuItem
                  key={`${item.key}-${index}`}
                  icon={subItem.icon}
                  label={subItem.label}
                  href={subItem.href}
                />
              )
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <PageWrapper>
      <div
        style={{
          background: "linear-gradient(180deg, #5525EB 0%, #1A0E41 100%)",
        }}
        className="w-64 h-[95vh] purple-scroll text-white rounded-[27px] flex flex-col pl-4 overflow-y-auto"
      >
        <div className="pr-4">
          <div className="text-center text-lg font-semibold mb-6 mt-10">
            <img
              src={Logo}
              alt="logo"
              className="w-[36px] h-[51px] object-contain mx-auto"
            />
          </div>
          <img src={Line} alt="line" className="mb-6" />
        </div>
        {filteredMenuItems.map((item) => (
          <MenuSection key={item.key} item={item} />
        ))}
      </div>
    </PageWrapper>
  );
};

export default Sidebar;
